import { ComponentProps } from "react";

export default function MenuIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <line y1="3.5" x2="16" y2="3.5" stroke="currentColor" />
      <line y1="11.5" x2="16" y2="11.5" stroke="currentColor" />
    </svg>
  );
}
